import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { PlatformConfig } from './settings.types'

const CONFIG_KEY = ['admin', 'config'] as const

/** Charge le paramétrage tarifaire courant (GET /admin/config). */
export function usePlatformConfig() {
  return useQuery<PlatformConfig>({
    queryKey: CONFIG_KEY,
    queryFn: async () => {
      const { data } = await api.get<PlatformConfig>('/admin/config')
      return data
    },
  })
}

/**
 * Met à jour le paramétrage (PATCH /admin/config) puis rafraîchit le cache de
 * la query avec la config renvoyée par l'API (déjà invalidée côté Redis).
 */
export function useUpdatePlatformConfig() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: Partial<PlatformConfig>) => {
      const { data } = await api.patch<PlatformConfig>('/admin/config', payload)
      return data
    },
    onSuccess: (data) => {
      queryClient.setQueryData(CONFIG_KEY, data)
    },
  })
}
